import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Chart from 'react-google-charts';
import Card from '../../Cards';
import Message from './Message';
import {
  countBy,
  getDate,
  getChartData,
  getWeekRanges,
} from './DatesAnalytics';

export default function ChartOpinions({ analyticsOpinion }) {
  //const [anchorEl, setAnchorEl] = useState(null);
  //const [option, setOption] = useState('week');
  //const [apply, setApply] = useState(false);

  const weekRanges = getWeekRanges('month');
  const data = getChartData(analyticsOpinion, 'opinions', 'month');
  /*const initial = getChartData(analyticsOpinion, 'messages', 'week');
  const [data, setData] = useState(initial);

   const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOption = (event, option) => {
    setApply(false);
    setOption(option);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const applyFilter = () => {
    setApply(true);
    setAnchorEl(null);
    setData(getChartData(analyticsOpinion, 'messages', option));
  }; 

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  */
 

  return (
    <div style={{ height: 440, marginBottom: 24 }}>
      <Card
        title="Total de opiniones recibidas"
        subtitle1={getDate('month')}
        subtitle2={`${countBy('month', analyticsOpinion)} opiniones`}
        //filter={true}
        link={
          analyticsOpinion.length > 0 ? (
            <Link
              to="/dashboard/opiniones"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              Ver mis opiniones
            </Link>
          ) : (
            false
          )
        }
        linkPosition="bottom"
      >
        <div
          className="chart"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {analyticsOpinion.length > 0 ? (
            <>
              <div
                style={{
                  /* width: isMobile && small ? '50%' : '60%' */

                  width: '50%',
                }}
              >
                <Chart
                  width={'100%'}
                  height={'298px'}
                  chartType="PieChart"
                  loader={<div style={{marginBottom:16}}>Cargando gráfica...</div>}
                  data={data}
                  options={{
                    legend: 'none',
                    colors: ['#013957', '#106c9d', '#57a4cc', '#478eb5'],
                    pieHole: 0.7,
                    pieSliceText: 'none',
                    chartArea: {
                      width: '80%',
                      height: '75%',
                      backgroundColor: 'transparent',
                    },
                    //vAxis: {format:'none'}
                  }}
                  rootProps={{ 'data-testid': '3' }}
                />
              </div>
              <div className="legend legend-opinions">
                <div style={{ paddingLeft: 20 }}>
                  <div className="legend-opinions-items">
                    <div
                      className="legend-opinions-square"
                      style={{
                        backgroundColor: '#013957',
                      }}
                    ></div>
                    <span className="legend-text">{weekRanges[0]}</span>
                    <span className="legend-value">
                      {data[1][1]}
                    </span>
                  </div>
                  <div className="legend-opinions-items">
                    <div
                      className="legend-opinions-square"
                      style={{
                        backgroundColor: '#106c9d',
                      }}
                    ></div>
                    <span className="legend-text">{weekRanges[1]}</span>
                    <span className="legend-value">
                      {data[2][1]}
                    </span>
                  </div>
                  <div className="legend-opinions-items">
                    <div
                      className="legend-opinions-square"
                      style={{
                        backgroundColor: '#57a4cc',
                      }}
                    ></div>
                    <span className="legend-text">{weekRanges[2]}</span>
                    <span className="legend-value">
                      {data[3][1]}
                    </span>
                  </div>
                  <div className="legend-opinions-items">
                    <div
                      className="legend-opinions-square"
                      style={{
                        backgroundColor: '#478eb5',
                      }}
                    ></div>
                    <span className="legend-text">{weekRanges[3]}</span>
                    <span className="legend-value">
                      {data[4][1]}
                    </span>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Message 
              title={'Sin opiniones'}
              description={'En el momento en que comiences a recibir opiniones te mostraremos las gráficas correspondientes.'}
              reminder={'No olvides pedir opinión a tus clientes.'}
            />
          )}
        </div>
      </Card>
    </div>
  );
}
